"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var interfaces_1 = require("../../data/interfaces");
var moment_1 = __importDefault(require("moment"));
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var getRulesByUserProfileType = function (rules, userProfileType) {
    var newRules;
    switch (userProfileType) {
        case interfaces_1.UserProfileType.Student:
            newRules = rules.student;
            break;
        case interfaces_1.UserProfileType.Staff:
            newRules = rules.staff;
            break;
        case interfaces_1.UserProfileType.Others:
            newRules = rules.others;
            break;
        default:
            newRules = {};
            console.log("No rules were found for userProfileType: " + userProfileType);
            break;
    }
    return newRules;
};
exports.getRulesByUserProfileType = getRulesByUserProfileType;
var EASTERN_TIME_ZONE = "America/New_York";
var getFormatDateNow = function () { return moment_1.default().format("MMMM Do YYYY"); };
exports.getFormatDateNow = getFormatDateNow;
var convertToLocalDate = function (date) {
    return moment_timezone_1.default(date).tz(EASTERN_TIME_ZONE).format("MMM D, YYYY h:mm A zz");
};
exports.convertToLocalDate = convertToLocalDate;
var convertToLocalDateFormat = function (date) { return moment_1.default(date).format("MM/DD/YYYY"); };
exports.convertToLocalDateFormat = convertToLocalDateFormat;
var DELIMITER = "<<@>>";
exports.DELIMITER = DELIMITER;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGVscGVyLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvbGliL2Z1bmN0aW9ucy9oZWxwZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxvREFBcUQ7QUFDckQsa0RBQTJCO0FBQzNCLG9FQUE0QztBQUU1QyxJQUFNLHlCQUF5QixHQUFHLFVBQUMsS0FBSyxFQUFFLGVBQWU7SUFDckQsSUFBSSxRQUFRLENBQUE7SUFDWixRQUFRLGVBQWUsRUFBRTtRQUNyQixLQUFLLDRCQUFlLENBQUMsT0FBTztZQUN4QixRQUFRLEdBQUcsS0FBSyxDQUFDLE9BQU8sQ0FBQTtZQUN4QixNQUFLO1FBRVQsS0FBSyw0QkFBZSxDQUFDLEtBQUs7WUFDdEIsUUFBUSxHQUFHLEtBQUssQ0FBQyxLQUFLLENBQUE7WUFDdEIsTUFBSztRQUVULEtBQUssNEJBQWUsQ0FBQyxNQUFNO1lBQ3ZCLFFBQVEsR0FBRyxLQUFLLENBQUMsTUFBTSxDQUFBO1lBQ3ZCLE1BQUs7UUFFVDtZQUNJLFFBQVEsR0FBRyxFQUFFLENBQUE7WUFDYixPQUFPLENBQUMsR0FBRyxDQUFDLDhDQUE0QyxlQUFpQixDQUFDLENBQUE7WUFDMUUsTUFBSztLQUNaO0lBQ0QsT0FBTyxRQUFRLENBQUE7QUFDbkIsQ0FBQyxDQUFBO0FBa0JHLDhEQUF5QjtBQWhCN0IsSUFBTSxpQkFBaUIsR0FBRyxrQkFBa0IsQ0FBQTtBQU01QyxJQUFNLGdCQUFnQixHQUFHLGNBQU0sT0FBQSxnQkFBTSxFQUFFLENBQUMsTUFBTSxDQUFDLGNBQWMsQ0FBQyxFQUEvQixDQUErQixDQUFBO0FBVzFELDRDQUFnQjtBQVRwQixJQUFNLGtCQUFrQixHQUFHLFVBQUMsSUFBSTtJQUM1QixPQUFBLHlCQUFjLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBRSxDQUFDLGlCQUFpQixDQUFDLENBQUMsTUFBTSxDQUFDLHVCQUF1QixDQUFDO0FBQTFFLENBQTBFLENBQUE7QUFTMUUsZ0RBQWtCO0FBUHRCLElBQU0sd0JBQXdCLEdBQUcsVUFBQyxJQUFJLElBQUssT0FBQSxnQkFBTSxDQUFDLElBQUksQ0FBQyxDQUFDLE1BQU0sQ0FBQyxZQUFZLENBQUMsRUFBakMsQ0FBaUMsQ0FBQTtBQVF4RSw0REFBd0I7QUFONUIsSUFBTSxTQUFTLEdBQUcsT0FBTyxDQUFBO0FBT3JCLDhCQUFTIn0=